import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得 campaign 列表
export function getCampaignList(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/campaigns/",
        method: "get",
        ...config,
    })
}

// 新增 campaign
export function createCampaign(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/`,
        method: "post",
        ...config,
    })
}

// 複製 campaign
export function copyCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/copy/`,
        method: "post",
        ...config,
    })
}

// 取得單一 campaign
export function getCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/`,
        method: "get",
        ...config,
    })
}

// 更新 campaign
export function updateCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/`,
        method: "put",
        ...config,
    })
}

// 部分更新 campaign
export function patchCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/`,
        method: "patch",
        ...config,
    })
}

// 刪除 campaign
export function deleteCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/`,
        method: "delete",
        ...config,
    })
}

// 取得單一 campaign 的分析資料
export function getCampaignAnalytics(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/`,
        method: "get",
        ...config,
    })
}

// 取得單一 campaign A/B test的分析資料
export function getCampaignABTestResult(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/ab-test-result/`,
        method: "get",
        ...config,
    })
}

// 取得單一 campaign 數據詳情資訊
export function getCampaignBehaviorAnalytics(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/behavior-summary/`,
        method: "get",
        ...config,
    })
}

// 取得單一 campaign 數據的點擊成效資訊
export function getCampaignLinkAnalytics(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/campaign-link/`,
        method: "get",
        ...config,
    })
}

// 取得單一 campaign 活動名單
export function getCampaignMemberList(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/member-list/`,
        method: "get",
        ...config,
    })
}

// 匯出單一 campaign 活動名單
export function exportCampaignMemberList(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/analytics/member-list/export/`,
        method: "post",
        ...config,
    })
}

// 提交 campaign 送審
export function submitCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/submit/`,
        method: "post",
        ...config,
    })
}

// 獲得 campaign 的審核者
export function getCampaignReviewers(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/reviewer/`,
        method: "get",
        ...config,
    })
}

// 審核 campaign
export function reviewCampaign(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${id}/review/`,
        method: "post",
        ...config,
    })
}

// 取消活動
export function cancelCampaign(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/campaigns/${uuid}/cancel/`,
        method: "post",
        ...config,
    })
}

// 取得 campaign 各狀態數量
export function getCampaignStatusCount(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/campaigns/counts/",
        method: "get",
        ...config,
    })
}

// 取得 campaign 活動管道
export function getCampaignMediaType(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/campaigns/media-type/",
        method: "get",
        ...config,
    })
}

// 取得 campaign 類型
export function getCampaignType(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/campaigns/type/",
        method: "get",
        ...config,
    })
}

// 取得 campaign 活動狀態
export function getCampaignStatus(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/campaigns/status/",
        method: "get",
        ...config,
    })
}
